<script lang="ts">
import { ThemeType } from '@goodlifeplus/themes'
import { defineComponent } from 'vue'

import HomeClubView from './HomeClubView.vue'
import HomeView from './HomeView.vue'

/**
 * The "Home" layout provider.
 */
export default defineComponent({
  components: {
    HomeClubView: HomeClubView,
    HomeView: HomeView,
  },
  setup() {
    return {
      ThemeType,
    }
  },
}) as new (...args: any[]) => any // lifted from vue/test-utils
</script>

<template>
  <HomeClubView v-if="$theme.type === ThemeType.Club" />
  <HomeView v-else />
</template>
